import { render, staticRenderFns } from "./approval.vue?vue&type=template&id=7d3de42a"
import script from "./approval.vue?vue&type=script&lang=ts"
export * from "./approval.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports